module.exports = __webpack_public_path__ + "static/media/leksefri.c7331d23.mp3";